export const CONTACT = {
  company: "Tourist Junction Private Limited",
  address: "Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India",
  email: "info.touristjunction@gmail.com",
  phone: "+91 96070 14213",
  phoneHref: "tel:+919607014213",
  hours: "Monday to Saturday, 10:00 AM – 6:00 PM IST",
  grievanceName: "Mr. Tushar Kamalakar Shinde",
  grievanceRole: "Chief Executive Officer, Tourist Junction Private Limited",
};

export const PRIVACY_TXT = `Middle Man ("Middle Man", "Platform", "we", "us") is operated by Tourist Junction Private Limited (CIN available on request), registered at Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India. This Privacy Policy explains what information we collect, why we collect it, who we share it with, how long we keep it, and how you can exercise your rights.

Effective from: 2026-09-10.

1. INFORMATION WE COLLECT
We only collect information the Platform actually needs to run.

1.1 Account information (all users)
   - Mobile number — used as your primary identifier and for OTP-based login through our SMS gateway.
   - Full name.
   - Email address (optional; only if you provide it).
   - Home / work city and, if you set it, a written street address.
   - Preferred language selection (interface only).
   - Profile photo (optional; you can leave this blank).
   - City-level latitude/longitude when you grant location permission, so the app can canonicalise your area to a known city/district/taluka.

1.2 KYC information (Middle Men only)
   When you register as a service provider ("Middle Man") the app collects:
   - Aadhaar number and a photo of the Aadhaar card.
   - PAN number and a photo of the PAN card.
   - A live selfie for face-match against the ID photo.
   These are used solely to verify that you are a real person with the right to work on the Platform. Numbers are stored in our database, images are stored as files on our servers, and none of it is shared publicly, sold or used for advertising.

1.3 Location information — foreground only
   Location is captured only while the app is open in the foreground. Specifically:
   - Reverse-geocoded city / district / taluka on the Home screen so you see local Middle Men.
   - Live GPS coordinates of the Middle Man during an active work request, so you can watch the ETA and route on the map. Points are recorded on the assigned work_request document and are capped at 500 points per trip.
   - Live GPS coordinates of the customer during an active work request, only if the customer has chosen to share their live location.
   We do NOT track your location in the background, we do NOT keep a permanent location history, and we do NOT sell location data. Tracking stops as soon as the work request is completed, cancelled or you deny/revoke the permission.

1.4 Photos and files
   - Customer task photos: images you attach to a work request (for example a receipt or a picture of what needs to be picked up) are stored on our servers and shared only with the specific Middle Man you assigned.
   - Middle Man KYC photos (see 1.2).
   - Middle Man profile photo (if you upload one).
   We access the camera / photo library only at the moment you tap a specific button (upload photo, take selfie, etc.). We do not scan your photo library in the background.

1.5 Payment information
   - Subscription payments are processed by Razorpay. Middle Men enter their payment credentials directly on Razorpay's PCI-DSS-compliant checkout; we never see or store full card numbers, CVVs, UPI PINs, net-banking passwords or OTPs sent by your bank.
   - What our server stores: Razorpay order IDs, subscription IDs, plan IDs, amounts, gateway-supplied statuses and the last-four of the payment reference where available.
   - Middle Men choose ONE payout method during registration — either UPI (preferred) or bank transfer. If UPI is selected we only store the VPA; bank fields are cleared. If bank is selected we store the account number, IFSC and holder name; the UPI field is cleared. We never collect both. Payout details are shown only to the paying customer for direct settlement and can be removed at any time.

1.5A Safety / escalation contacts (Middle Men only, optional)
   - Emergency contact: one mobile number of a trusted person used ONLY by the in-app "Emergency Assistance" button that can be triggered during a live job. Not shown to customers.
   - Backup contact 1 & 2 (optional): up to two secondary numbers used ONLY by our support team when the primary mobile is unreachable during a documented fraud investigation or safety incident. Not shown to customers, not used for marketing, not shared with any third party. You can add, edit or remove these numbers any time from Profile → Personal Details.

1.6 Authentication / OTP
   - One-time passcodes (OTPs) sent by SMS Gateway Hub for mobile-number verification.
   - Session tokens (JWT) issued after successful login; stored in the device's secure storage (Keychain on iOS, EncryptedSharedPreferences on Android, IndexedDB on web).
   - Optional password (hashed with bcrypt) if you choose to set one from Profile.

1.7 Communication content
   - In-app notifications we send you about your work requests, subscription status, T&C updates and platform announcements are stored in your notifications feed.
   - Ratings and reviews you post are visible to the reviewed user and other users on the Platform.

1.8 Device and log data
   - App version, operating-system version, device model.
   - IP address of the request (recorded in server access logs for security and abuse investigation).
   - Server-side error and audit logs of admin actions.
   We do NOT integrate any third-party analytics, advertising or crash-reporting SDK in this build (no Firebase Analytics, no Google Ads, no Sentry, no Mixpanel, no Facebook SDK). If we add any in the future we will update this policy and bump its version so you are asked to re-review it.

1.9 Local cache on your device
   The app uses standard React Native storage APIs to cache:
   - Your session token (in device secure storage).
   - A copy of your last-known profile for offline continuity.
   - Draft work-request data so you don't lose progress on a slow network.
   You can clear this by uninstalling the app or deleting your account (see Section 6).

2. HOW WE USE YOUR INFORMATION
We use the data described above to:
   - Show relevant nearby Middle Men and let customers send work requests.
   - Verify Middle Man identity (KYC) before allowing them to accept work.
   - Deliver live-tracking, ETAs and arrival alerts during a work request.
   - Send you transactional messages (booking updates, OTPs, T&C updates).
   - Process subscription payments through Razorpay.
   - Investigate abuse, fraud and safety incidents.
   - Meet our legal, tax and grievance-redressal obligations.
   - Improve the Platform based on aggregated, non-identifying usage patterns.
We do NOT use your data for behavioural advertising, sell it to data brokers, or share it with third-party marketing services.

3. WHO WE SHARE INFORMATION WITH
   - The other party to a specific work request (customer ↔ assigned Middle Man). They see the details needed to complete that particular request — for example the destination address and the customer contact number — but NOT your full profile or KYC.
   - Payment processor: Razorpay, only the fields required to process a subscription (name, mobile, email, plan and amount).
   - SMS gateway: SMS Gateway Hub, only your mobile number and the OTP text for verification messages.
   - Map / routing services: OpenStreetMap tile servers and the OSRM public routing service, only the coordinates needed to render the map and compute an ETA. We do NOT use Google Maps, so no data goes to Google Maps.
   - Infrastructure hosting: our servers and MongoDB database are hosted with the cloud provider currently powering the deployment; database access is restricted to authorised personnel.
   - Government authorities and courts: when we receive a lawful, written request under Indian law and are compelled to comply.
We never sell your personal information to anyone.

4. DATA SECURITY
   - All traffic between your device and our servers travels over HTTPS/TLS.
   - Passwords are hashed with bcrypt using a strong work factor. We never store plaintext passwords and cannot recover them.
   - Aadhaar and PAN numbers are stored encrypted at rest and are accessible only to the verification module and administrators explicitly assigned KYC review rights.
   - JWT session tokens are short-lived and stored in device secure storage; they never appear in URLs or query strings.
   - Admin actions are recorded in an internal audit log.
   - Despite these safeguards, no online service can guarantee absolute security. If we ever discover a personal-data breach that is likely to result in harm, we will notify affected users and CERT-In as required by law.

5. HOW LONG WE KEEP INFORMATION
   - Account profile: for as long as the account is active. If you request deletion (Section 6) it is removed within 30 days, subject to point (d) below.
   - Work request records: retained for the duration of the engagement plus a reasonable period thereafter to handle disputes, refunds and legal obligations.
   - Tracking-trail GPS points: capped at 500 points per trip and removed once the trip is closed or when the account is deleted.
   - KYC documents: retained while your Middle Man account is active. Removed on account deletion, subject to point (d).
   - Payment and subscription records: retained for the period mandated by Indian tax / accounting law (currently up to 8 financial years).
   - Notification and audit logs: retained for a rolling 12-month window unless required longer for a legal matter.
   - Legal-retention override (d): where retention is required by law (for example an open dispute, an unresolved tax audit, or a live court order), the specific record will be kept until the legal obligation is discharged, even if you have requested deletion.

6. ACCOUNT DELETION AND YOUR CHOICES
6.1 Delete your account from inside the app
   Open the app → Profile → Delete Account and confirm the two-step prompt. The request is routed to the admin panel for review. Standard requests are completed within 30 days.

6.2 Delete your account via the public web page
   You can also submit a deletion request from any browser at:
     https://middleman.co.in/legal/account-deletion
     (or the corresponding URL displayed on your device's app store listing).
   Requests submitted from the public page are handled with the same 30-day SLA.

6.3 Other rights
   - Access: request a copy of the personal information we hold about you.
   - Correction: fix incorrect information — most fields can be edited from Profile → Edit Profile directly.
   - Restrict / object: ask us to pause processing of specific data.
   - Portability: request a machine-readable export where technically feasible.
   - Withdraw consent: revoke camera, location or notification permission from your device settings at any time. This may reduce Platform functionality but never blocks account access.
   To exercise a right or ask a question, write to info.touristjunction@gmail.com from your registered mobile / email.

7. CHILDREN
The Platform is not intended for anyone under the age of 18. If you believe a minor has created an account, please write to info.touristjunction@gmail.com and we will delete the account promptly.

8. INTERNATIONAL TRANSFERS
Our servers are located in India. If you use the app from outside India your information will still be processed in India under Indian law.

9. THIRD-PARTY LINKS
The Platform may contain links to third-party websites or services (for example Razorpay checkout, OpenStreetMap tiles). This policy does not cover those third parties. Please review their own privacy policies.

10. CHANGES TO THIS POLICY
When we make a material change to this policy the version number displayed in the app increases and existing users will be prompted to review the new version before their next work request. The version number and effective date are shown inside this document.

11. GRIEVANCE AND CONTACT
Grievance Officer / Data Protection Contact (in compliance with Rule 3(2)(a) of the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021):
   Name       : Mr. Tushar Kamalakar Shinde
   Designation: Chief Executive Officer, Tourist Junction Private Limited
   Address    : Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India
   Phone      : +91-96070 14213
   Email      : info.touristjunction@gmail.com
   We acknowledge grievances within 48 working hours and aim to resolve them within the timelines set by the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021 and the Digital Personal Data Protection Act, 2023 as they become applicable.

Effective from 2026-09-10.`;

export const TERMS_TXT = `By submitting a Work Request through the Middle Man platform you confirm that you have read, understood and agreed to the terms below.

1. ABOUT MIDDLE MAN
Middle Man (operated by Tourist Junction Private Limited, registered at Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India) is a technology marketplace that connects Customers with independent, self-employed service providers ("Middle Men") for courier, pickup, delivery, errand and other permitted local tasks.
Middle Man is NOT the employer of the service provider. We facilitate discovery, communication and Work Requests between two independent parties. The service provider is solely responsible for the actual performance of the task.

2. WORK REQUEST
When you Send Work you are making a request to a specific Middle Man; acceptance is at that Middle Man's discretion. A Work Request only becomes a confirmed engagement once the Middle Man explicitly accepts it inside the app.
You are responsible for the accuracy of all details you enter — pickup/delivery address, item description, contact number, date/time and any special instructions.

3. PRICING, RECOMMENDED RATES AND MUTUALLY DISCUSSED PRICING
The platform may display three kinds of pricing information for every service:
   (a) the Middle Man's own listed service charge,
   (b) the platform's Recommended Rate or Range (a non-binding guideline), and
   (c) "Mutually Discussed" pricing where the final amount is agreed directly between you and the Middle Man before the work begins.
Unless the app explicitly states otherwise, the amount you actually pay is the amount you and the Middle Man agree on before the task starts. A Recommended Rate is a reference guideline, not the final quoted price.
Platform fees, taxes and payment-gateway charges (if any) will be shown clearly during checkout.

4. PAYMENT, CANCELLATION AND REFUNDS
Payments made through Razorpay or another supported gateway are subject to that gateway's terms in addition to ours.
If you cancel a Work Request AFTER the Middle Man has begun travelling or performing the task, the Middle Man may retain a fair portion of the agreed price to cover time and expenses incurred, subject to the platform's cancellation rules displayed at the time of cancellation.
Refunds, where applicable, are processed to the original payment method within a reasonable time.

5. YOUR RESPONSIBILITIES
You agree to:
   (a) Provide accurate and truthful information for every Work Request.
   (b) Not request any illegal, dangerous, restricted or prohibited item or activity (see Section 7).
   (c) Treat the Middle Man courteously and pay the agreed amount promptly on completion.
   (d) Be reachable on the contact number linked to your account during the task window.
   (e) Personally verify that any package or belonging handed over does not contain prohibited items.

6. MIDDLE MAN RESPONSIBILITIES
Independent Middle Men who accept work through the platform are required to:
   (a) Complete the task to the best of their ability and within a reasonable time.
   (b) Handle Customer belongings, cash-on-delivery and personal information with care and confidentiality.
   (c) Not carry, transport or handle any prohibited item.
   (d) Comply with all applicable local laws, traffic rules and safety norms.

7. PROHIBITED GOODS AND ACTIVITIES
The following are strictly prohibited on the platform regardless of how a Work Request is described (including if described as an "errand"):
   • Weapons, ammunition, explosives, fireworks
   • Narcotics, psychotropic substances and drugs prohibited under law
   • Live animals, plants or biological material where transport requires a licence
   • Hazardous chemicals, flammables, corrosives and radioactive material
   • Cash in transit above the limit permitted by law
   • Stolen goods, counterfeit currency or documents
   • Human remains, body parts or medical samples requiring a licensed courier
   • Items whose sale, possession or transport is restricted by Indian law
The platform reserves the right to refuse, cancel or report any Work Request that reasonably appears to involve prohibited goods or activities.

8. COURIER, PICKUP, DELIVERY AND ERRAND LIMITATIONS
Middle Man is a marketplace and NOT a licensed courier or logistics operator. High-value shipments, sealed consignments requiring proof-of-manifest, dangerous goods, temperature-controlled goods and time-critical medical deliveries should be handled through a licensed courier — do not use the platform for these.
Weight, size and value limits (if any) will be displayed inside the app for each service.

9. PERSONAL BELONGINGS AND PACKAGE RESPONSIBILITY
The Customer is responsible for accurately declaring the contents of any package. The Middle Man is not obliged to accept a package whose contents cannot be reasonably verified.
Neither Middle Man (the platform) nor the individual Middle Man carrying out the task will be liable for undeclared valuables, cash or fragile items packed unsafely by the Customer. Any dispute over lost, damaged or delayed items will be handled per the platform's grievance procedure.

10. DELAYS, FAILED DELIVERY AND CANCELLATION
The platform does not guarantee a fixed delivery time or turnaround. Estimated times of arrival ("ETA") shown in the app are best-effort estimates based on real-time signals and may vary due to traffic, weather, availability or events beyond anyone's control.
If a Middle Man is unable to complete a task, both parties will be notified and the Customer may cancel or reassign. Refunds (if any) will be handled per Section 4.

11. USER-TO-USER COMMUNICATION
Communication between Customer and Middle Man may take place through the in-app chat, calls masked by the platform or direct calls where permitted. You agree not to use these channels to harass, defraud, spam or exchange contact details for purposes unrelated to the Work Request.

12. RATINGS, REVIEWS AND FEEDBACK
Both Customers and Middle Men may rate and review each other after a task. Reviews must be honest, based on personal experience and free of abusive, defamatory or discriminatory language. The platform may remove reviews that violate this policy.

13. FRAUD, MISUSE AND ACCOUNT SUSPENSION
The platform reserves the right to suspend, restrict or terminate any account that:
   (a) Attempts to use the service for prohibited goods or activities.
   (b) Submits fraudulent Work Requests, KYC documents or payment details.
   (c) Chargebacks or repeatedly cancels after acceptance without valid reason.
   (d) Abuses, threatens or harms Middle Men, Customers or platform staff.
   (e) Violates any material term of this document.

14. PRIVACY AND PERSONAL INFORMATION
Your personal information is handled in accordance with the Middle Man Privacy Policy, available at any time inside the app. By using the platform you consent to us processing your data as described there.
The Middle Man responsible for a specific task may receive limited details (pickup/drop address, contact number, task instructions) required to complete that task; they must not retain or reuse that data outside the task.

15. PLATFORM AVAILABILITY AND THIRD-PARTY SERVICES
We aim to keep the service available at all times but do not guarantee uninterrupted access. Portions of the service rely on third-party providers (maps, payment gateways, SMS gateways, cloud infrastructure). Their availability is outside our reasonable control.
Middle Man is not responsible for outages caused by the Customer's device, network connectivity, operating-system permissions or third-party service failures.

16. LIMITATION OF LIABILITY
To the maximum extent permitted by law, Middle Man's total liability for any claim arising out of or connected with a Work Request is limited to the platform fees actually charged to the Customer for that specific Work Request, capped in aggregate at the amount actually paid by the Customer to the platform in the ninety (90) days preceding the claim.
Middle Man is not liable for any indirect, consequential, incidental, special or punitive damages, including loss of profit, loss of goodwill or loss of data.

17. INDEMNIFICATION
You agree to indemnify and hold harmless Middle Man, its officers, employees and affiliates from any claim, loss or damage arising from your breach of these terms, your violation of applicable law or your interaction with a Middle Man / Customer through the platform.

18. INTELLECTUAL PROPERTY
The Middle Man brand, logo, app content, software, database and design are the intellectual property of Tourist Junction Private Limited and its licensors. You may not copy, modify, resell, decompile or exploit any part of the service without prior written permission.

19. TERMINATION
You may stop using the platform at any time by deleting your account from Profile → Settings. We may terminate or suspend your access if we reasonably believe you have breached these terms or applicable law. Work Requests that are in progress at termination will be handled per the platform's grievance procedure.

20. CHANGES TO THESE TERMS
We may update these Terms & Conditions from time to time. When a material change is published, the version number displayed in the app changes and existing users will be prompted to review and accept the new version before submitting further Work Requests. The version and effective date are displayed inside this document.

21. GOVERNING LAW AND JURISDICTION
These Terms are governed by the laws of India. Any dispute arising out of or in connection with this document shall be subject to the exclusive jurisdiction of the competent courts of the district in which Tourist Junction Private Limited's registered office is located.

22. GRIEVANCE AND CONTACT
For grievances, complaints, refund queries or reporting of misuse, please write to info.touristjunction@gmail.com. Our grievance officer will acknowledge within 48 working hours and endeavour to resolve the matter within a reasonable time as required under applicable law.

Effective from 2026-09-10.`;

export const PRODUCT_ORDER_TXT = `By placing a Product Order through the Middle Man platform you confirm that you have read, understood and agreed to the terms below.

1. ABOUT THIS SERVICE
Middle Man (operated by Tourist Junction Private Limited, registered at Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India) is a marketplace that connects Customers with nearby independent Middle Men who list and deliver products. Middle Man is a facilitator — the seller and delivery provider is the independent Middle Man, not the platform.

2. PRODUCT LISTINGS AND PRICING
Product prices, delivery charges, stock and product details are set by the individual Middle Man and shown to you before you confirm the order. The price you see at checkout (product price + delivery charge) is the final amount payable for that order. MRP shown on product packaging may differ from the Middle Man's selling price, which is displayed transparently before you order.

3. DELIVERY ADDRESS AND LOCATION
The delivery address, phone number and optional GPS location you provide are used ONLY to fulfil that specific order. Your exact address and GPS coordinates are shared with the Middle Man only AFTER they accept your order, and are never shown publicly on any product, profile or listing. Do not misuse the address of others.

4. ORDER ACCEPTANCE
Your order is a request. The Middle Man may accept or reject it (for example, if the product is out of stock). If rejected, you will be notified with the reason and nothing is payable.

5. PAYMENT
Payment is settled directly between you and the Middle Man (cash or the Middle Man's UPI shown after delivery/job completion). Middle Man platform does not collect, hold or refund product payments. Platform subscription fees paid by Middle Men are separate and unrelated to your product orders.

6. PRODUCT CONDITION AND RETURNS
Inspect the product at delivery. Perishable goods, opened personal-care or health products cannot be returned. For defective or incorrect items, raise it with the Middle Man immediately at delivery and use the in-app complaint option if unresolved. Warranty, where applicable, is provided by the product brand/manufacturer as stated on the listing.

7. RESTRICTED PRODUCTS
Prescription medicines, tobacco/nicotine, alcohol, weapons and other legally restricted items are never permitted on the platform. Report any such listing immediately through the complaint option.

8. ACCURATE INFORMATION
You must provide a correct delivery address and a reachable phone number. Failed delivery due to wrong address or unreachable phone may attract a re-delivery charge mutually agreed with the Middle Man.

9. CONDUCT
Abusive behaviour towards the Middle Man, fraudulent orders, or refusal to pay for accepted and delivered orders may lead to suspension of your account.

10. GRIEVANCE
Grievance Officer: Mr. Tushar Kamalakar Shinde, CEO, Tourist Junction Private Limited, Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India. Phone: +91-96070 14213. Email: info.touristjunction@gmail.com.

Effective from 2026-09-11.`;

export const REFUND = {
  intro: [
    "This policy explains how cancellations, refunds and deliveries work on Middle Man — for both service Work Requests and product marketplace orders. Together with our Terms & Conditions, Product Order & Delivery Terms and Privacy Policy, it governs your use of Middle Man. **Effective from: 11 September 2026.**",
  ],
  sections: [
    {
      title: "1. Service Work Request cancellations",
      blocks: [
        { ul: [
          "You may cancel a Work Request free of charge before the Middle Man has begun travelling or performing the task.",
          "If you cancel AFTER the Middle Man has begun travelling or performing the task, the Middle Man may retain a fair portion of the agreed price to cover time and expenses incurred, subject to the platform's cancellation rules displayed at the time of cancellation.",
          "If a Middle Man is unable to complete a task, both parties are notified and you may cancel or reassign the request.",
        ]},
      ],
    },
    {
      title: "2. Product order cancellations",
      blocks: [
        { ul: [
          "A product order is a request until the Middle Man (seller) accepts it. You can cancel in-app only while the order is pending.",
          "If the Middle Man rejects the order (for example, out of stock), you are notified with the reason and nothing is payable.",
          "After acceptance, cancellation or return is handled directly with the Middle Man as per the Product Order & Delivery Terms.",
        ]},
      ],
    },
    {
      title: "3. Product payments and refunds",
      blocks: [
        { ul: [
          "Product payments are settled directly between you and the Middle Man (cash, or the Middle Man's UPI shown after delivery).",
          "The Middle Man platform does not collect, hold, reverse or refund product payments.",
          "Refunds or replacements for defective or incorrect items are agreed with the Middle Man; use the in-app complaint option if unresolved.",
        ]},
      ],
    },
    {
      title: "4. Delivery, inspection and returns",
      blocks: [
        { ul: [
          "Inspect the product at the time of delivery.",
          "Perishable goods, opened personal-care or health products cannot be returned.",
          "Warranty, where applicable, is provided by the product brand/manufacturer as stated on the listing.",
          "Failed delivery due to a wrong address or unreachable phone may attract a re-delivery charge mutually agreed with the Middle Man.",
        ]},
      ],
    },
    {
      title: "5. Subscription payments (Razorpay)",
      blocks: [
        { ul: [
          "Middle Man subscription payments are processed by Razorpay and are subject to Razorpay's terms in addition to ours.",
          "If you see a duplicate debit, or activation fails after a successful debit, write to info.touristjunction@gmail.com with your registered mobile and payment reference.",
          "Verified duplicate or failed-activation amounts are refunded to the original payment method within a reasonable time, depending on the bank / gateway.",
        ]},
      ],
    },
    {
      title: "6. Disputes and evidence",
      blocks: [
        { p: "Raise a dispute through the in-app complaint option or by emailing info.touristjunction@gmail.com. We review booking timelines, tracking points, chat history and photos, and both parties are informed of the outcome." },
      ],
    },
    {
      title: "7. Grievance and contact",
      blocks: [
        { lines: [
          "**Grievance Officer:** Mr. Tushar Kamalakar Shinde, CEO, Tourist Junction Private Limited",
          "**Address:** Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India",
          "**Phone:** +91 96070 14213",
          "**Email:** info.touristjunction@gmail.com",
        ]},
      ],
    },
  ],
};

export const MARKETPLACE = {
  intro: [
    "Middle Man is a marketplace where independent Middle Men (sellers) list and fulfil products for nearby customers. This policy explains how product listings, orders, payments and deliveries work. Middle Man is operated by Tourist Junction Private Limited, Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India.",
  ],
  sections: [
    {
      title: "1. Who sells on Middle Man",
      blocks: [
        { p: "Products are listed, priced, stocked and delivered by independent Middle Men — not by the platform. Middle Man is a facilitator: the seller and delivery provider is the independent Middle Man." },
      ],
    },
    {
      title: "2. Listings, pricing and stock",
      blocks: [
        { ul: [
          "Product prices, delivery charges, stock and product details are set by the individual Middle Man and shown before you confirm an order.",
          "The price you see at checkout (product price + delivery charge) is the final amount payable for that order.",
          "MRP shown on product packaging may differ from the Middle Man's selling price, which is displayed transparently before you order.",
        ]},
      ],
    },
    {
      title: "3. Listing review and compliance documents",
      blocks: [
        { ul: [
          "Listings and category-related compliance documents may be reviewed by our admin team before or after publishing.",
          "Sellers must keep required documents valid and current; listings linked to expired documents may be paused or removed until the documents are renewed.",
          "Platform review is an internal check — it is not government approval and does not guarantee legality, safety, efficacy or quality.",
        ]},
      ],
    },
    {
      title: "4. Prohibited products",
      blocks: [
        { ul: [
          "Prescription medicines, tobacco/nicotine, alcohol, weapons and other legally restricted items are never permitted on the platform.",
          "Weapons, ammunition, explosives, narcotics, hazardous chemicals, stolen goods, counterfeit currency or documents, and items whose sale, possession or transport is restricted by Indian law are strictly prohibited.",
          "Report any such listing immediately through the in-app complaint option.",
        ]},
      ],
    },
    {
      title: "5. Address privacy",
      blocks: [
        { p: "Your exact delivery address, phone number and optional GPS location are used only to fulfil that specific order. They are shared with the Middle Man only AFTER they accept your order, and are never shown publicly on any product, profile or listing." },
      ],
    },
    {
      title: "6. Payments",
      blocks: [
        { p: "Payment is settled directly between you and the Middle Man (cash, or the Middle Man's UPI shown after delivery). The platform does not collect, hold or refund product payments. Platform subscription fees paid by Middle Men are separate and unrelated to product orders." },
      ],
    },
    {
      title: "7. Cancellations, delivery and returns",
      blocks: [
        { ul: [
          "An order is a request until the Middle Man accepts it; in-app cancellation is available only while the order is pending.",
          "Inspect the product at delivery. Perishable goods, opened personal-care or health products cannot be returned.",
          "For defective or incorrect items, raise it with the Middle Man immediately at delivery and use the in-app complaint option if unresolved.",
        ]},
      ],
    },
    {
      title: "8. Moderation and platform limits",
      blocks: [
        { p: "The platform may remove listings, pause sellers or suspend accounts that breach these rules. Because sellers are independent, the platform does not guarantee product quality, availability or delivery times, and is not liable for the seller's performance — disputes are handled through the platform's grievance procedure (see Contact & Grievance)." },
      ],
    },
  ],
};

export const SELLER = {
  intro: [
    "This policy applies to every Middle Man who offers services or lists products on the Middle Man platform. Middle Man is operated by Tourist Junction Private Limited, Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India.",
  ],
  sections: [
    {
      title: "1. Independent status",
      blocks: [
        { p: "Middle Men are independent, self-employed service providers. Middle Man is NOT your employer. The platform facilitates discovery, communication and orders between you and customers; you are solely responsible for performing the work and for complying with all applicable laws." },
      ],
    },
    {
      title: "2. KYC and activation",
      blocks: [
        { ul: [
          "Registration requires your Aadhaar number and a photo of the Aadhaar card, your PAN number and a photo of the PAN card, and a live selfie for face-match against the ID photo.",
          "This information is used solely to verify that you are a real person with the right to work on the platform. It is never shared publicly, sold or used for advertising.",
          "False, forged or fraudulent submissions result in permanent suspension and may be reported to authorities.",
        ]},
      ],
    },
    {
      title: "3. Subscription",
      blocks: [
        { p: "Platform access for Middle Men runs on a subscription paid through Razorpay's PCI-DSS-compliant checkout. The platform never sees or stores your card number, CVV, UPI PIN or net-banking credentials. Payout details: you choose ONE payout method during registration — either UPI (only the VPA is stored) or bank transfer (account number, IFSC and holder name); never both." },
      ],
    },
    {
      title: "4. Listing standards",
      blocks: [
        { ul: [
          "Listings must be accurate: real photos, correct product details, honest stock and clear pricing including delivery charge.",
          "The price shown at checkout (product price + delivery charge) is the final amount payable by the customer — no hidden additions at the door.",
        ]},
      ],
    },
    {
      title: "5. Compliance documents",
      blocks: [
        { ul: [
          "Categories that require licences or compliance documents may be activated only after the required documents are provided.",
          "Keep your documents valid and current. Listings linked to expired documents may be paused or removed until renewed.",
          "Platform review of documents is an internal check, not government approval; legal responsibility for the products you sell remains with you.",
        ]},
      ],
    },
    {
      title: "6. Orders and delivery",
      blocks: [
        { ul: [
          "A customer order is a request until you accept it. Accept only orders you can actually fulfil; reject promptly (with a reason) when you cannot.",
          "You are responsible for delivering the correct product, in good condition, within the promised timeframe.",
          "The customer's exact address, phone and GPS location are shared with you only after you accept — use them only to fulfil that order.",
        ]},
      ],
    },
    {
      title: "7. Payments and refunds",
      blocks: [
        { ul: [
          "Product payment is settled directly between you and the customer (cash or your UPI shown after delivery). The platform does not collect, hold or refund product payments.",
          "Refunds or replacements for defective or incorrect items are your responsibility as the seller; unresolved cases may be escalated through the in-app complaint option.",
        ]},
      ],
    },
    {
      title: "8. Customer data",
      blocks: [
        { p: "Customer details you receive for a task or order (address, contact number, instructions) must be used only for that engagement, kept confidential, and never retained, reused or shared outside it." },
      ],
    },
    {
      title: "9. Conduct, records and enforcement",
      blocks: [
        { ul: [
          "Never list prohibited products (prescription medicines, tobacco/nicotine, alcohol, weapons or other legally restricted items).",
          "Fraudulent orders, fake documents, customer harassment or off-platform solicitation can lead to suspension or permanent termination.",
          "Keep records of your sales and compliance documents as required by law; you remain legally responsible for what you sell and deliver.",
        ]},
      ],
    },
  ],
};

export const HEALTHCARE = {
  intro: [
    "This notice applies to health-related products listed by independent Middle Men on the Middle Man marketplace. Middle Man is operated by Tourist Junction Private Limited, Office No. 301, Nawale IT Park, Narhe (N.V.), Pune 411041, Maharashtra, India.",
  ],
  sections: [
    {
      title: "1. What Middle Man is not",
      blocks: [
        { p: "Middle Man is not a doctor, pharmacy, diagnostic service or emergency medical provider. Nothing on the platform is medical advice, diagnosis or treatment." },
      ],
    },
    {
      title: "2. Current catalog scope",
      blocks: [
        { ul: [
          "Where health-related listings are active, the current catalog scope is limited to permitted first-aid, wellness, hygiene and over-the-counter type products.",
          "Prescription-only medicines are excluded from the current catalog and are never permitted to be listed.",
        ]},
      ],
    },
    {
      title: "3. Sellers remain responsible",
      blocks: [
        { ul: [
          "Health-related products are listed and delivered by independent Middle Men (sellers), who remain legally responsible for the products they sell, including any licences the law requires.",
          "Seller licences and compliance documents may be reviewed by the platform before or after listing.",
          "Platform review is an internal check — it is NOT government verification and does not guarantee the legality, safety, efficacy or quality of any product.",
        ]},
      ],
    },
    {
      title: "4. Customer precautions",
      blocks: [
        { ul: [
          "Read the product label and follow the manufacturer's instructions.",
          "Check expiry dates and packaging seals at delivery.",
          "Consult a qualified medical professional before using any health product if you are unsure, pregnant, elderly, or buying for a child.",
          "Do not use the platform for time-critical medical needs — see the emergency note below.",
        ]},
      ],
    },
    {
      title: "5. Emergencies and adverse reactions",
      blocks: [
        { p: "In a medical emergency, call your local emergency number or go to the nearest hospital — do not rely on the platform. If you experience an adverse reaction to a product, stop using it, seek medical attention, and then report the listing through the in-app complaint option." },
      ],
    },
    {
      title: "6. Reporting",
      blocks: [
        { p: "See a listing that should not be there — a prescription medicine, an expired product, a false health claim? Report it immediately through the in-app complaint option or write to info.touristjunction@gmail.com." },
      ],
    },
  ],
};
